import { defineMessages } from 'react-intl';

export const scope = 'app.components.globalNav.calendarNavLink';

export default defineMessages({
  schedule: {
    id: 'app.components.globalNav.calendarNavLink.schedule',
    defaultMessage: 'Schedule',
  },
});
